import { createTheme } from "@mui/material/styles";
import { deDE as coreDeDE } from "@mui/material/locale";
import { deDE as pickersDeDE } from "@mui/x-date-pickers/locales";

export const logamiTheme = createTheme(
  {
    palette: {
      mode: "light",

      primary: {
        main: "#5B5FC7",
        contrastText: "#FFFFFF",
      },

      secondary: {
        main: "#5E6073",
        contrastText: "#FFFFFF",
      },

      error: {
        main: "#BA1A1A",
        contrastText: "#FFFFFF",
      },

      background: {
        default: "#FBFBFE",
        paper: "#FFFFFF",
      },

      text: {
        primary: "#1B1B1F",
        secondary: "#47464F",
      },

      divider: "#C7C5D0",
    },

    typography: {
      fontFamily: [
        "Roboto",
        "Arial",
        "sans-serif",
      ].join(","),

      h1: {
        letterSpacing: "-0.01em",
      },
      h2: {
        letterSpacing: "-0.01em",
      },
      h3: {
        letterSpacing: "-0.01em",
      },
      h4: {
        letterSpacing: "-0.01em",
      },
      h5: {
        letterSpacing: "-0.01em",
      },
      h6: {
        letterSpacing: "-0.01em",
      },
    },
    components: {
      MuiAppBar: {
        defaultProps: {
          elevation: 0,
          color: "inherit",
        },
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            backgroundImage: "none",
            color: theme.palette.text.primary,
            boxShadow: "none",
            borderBottom: `1px solid ${theme.palette.divider}`,
          }),
        },
      },

      MuiToolbar: {
        styleOverrides: {
          root: ({ theme }) => ({
            minHeight: 56,

            [theme.breakpoints.up("sm")]: {
              minHeight: 64,
            },
          }),
        },
      },
    }
  },
  coreDeDE,
  pickersDeDE,
);
